import { render, staticRenderFns } from "./modal-point-applied.vue?vue&type=template&id=8b12fa2e&"
import script from "./modal-point-applied.vue?vue&type=script&lang=js&"
export * from "./modal-point-applied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports